<template>
  <div>
    <v-dialog v-model="show" max-width="406" flat elevation="0" persistent>
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title v-if="!successRequest" class="justify-center pb-0 mb-0">
          <v-autocomplete
            v-model="groupNameModel"
            :search-input.sync="groupName"
            v-on:keyup.enter="getGroups()"
            :items="groupItems"
            class="mt-0 pb-0 mb-2"
            outlined
            hide-details
            rounded
            :loading="loading"
            hide-selected
            item-text="Name"
            item-value="Id"
            :label="$t('labels.selectArea')"
            return-object
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("description.noContent") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
          <small class="grey--text my-0 py-0" style="font-size: 10px">
            {{ $t("description.searchDesc") }} <kbd class="mx-1">enter</kbd>
            {{ $t("description.pressButton") }}
          </small>
        </v-card-title>
        <v-card-title v-else>
            <div class="defaultColor--text font-weight-regular text-center px-12"
            style="font-size: 15px; line-height: 25px">{{successRequestDesc}}</div>
        </v-card-title>
        <v-card-actions
          v-if="!successRequest"
          class="justify-center align-center pb-5 mt-0"
        >
          <v-btn
            color="defaultColorLightTwo"
            class="white--text text-capitalize"
            :disabled="searchButtonDisabled"
            block
            elevation="0"
            rounded
            large
            :loading="loading"
            @click="requestLiveStream()"
          >
            {{ $t("buttons.sendRequest") }}
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else class="justify-center align-center pb-5 mt-0">
          <v-btn
            color="greenColor"
            class="white--text text-capitalize"
            block
            elevation="0"
            rounded
            large
            @click="closeModal"
          >
            {{ $t("buttons.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="closeModal" />
    </v-dialog>
  </div>
</template>

<script>
import GroupService from "../../services/GroupService";
import BroadcastService from "../../services/BroadcastService";
import DialogCloseButton from "../General/DialogCloseButton.vue";
import DescriptionDialog from "../General/DescriptionDialog.vue";

export default {
  data() {
    return {
      loading: false,

      groupName: "",
      groupNameModel: null,
      groupItems: [],

      successRequest: false,
      successRequestDesc: '',
    };
  },
  props: {
    visible: Boolean,
  },
  mounted() {},
  components: {
    DialogCloseButton,
    DescriptionDialog,
  },
  methods: {
    getGroups() {
      console.log("groupName :", this.groupName);
      this.loading = true;
      GroupService.getGroups(this.groupName)
        .then((res) => {
          console.log("groups :", res.data);
          this.groupItems = res.data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.loading = false;
        });
    },

    requestLiveStream() {
      console.log("request live stream");
      console.log("filter : ", this.groupNameModel);
      if (this.groupNameModel) {
        let body = {
          GroupIds: [[this.groupNameModel.Id.toString()]],
        };
        this.loading = true
        BroadcastService.requestStream(body)
          .then((res) => {
            this.successRequestDesc = res.data.Message
            this.successRequest = true;
          })
          .catch((err) => {
            showError(err);
          })
          .then(() => {
            this.loading = false;
          });
      }
    },

    closeModal() {
      this.loading = false;
      this.groupName = "";
      this.groupNameModel = null;
      this.groupItems = [];
      this.show = false;
      this.successRequestDesc = '';
      this.successRequest = false;
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },

    searchButtonDisabled: {
      get() {
        return this.groupNameModel ? false : true;
      },
    },
  },
  watch: {},
};
</script>
